var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviewClose = function SvgPreviewClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.22c.317.61.798 1.176 1.411 1.679C6.131 11.308 8.89 12.22 12 12.22c3.11 0 5.87-.913 7.589-2.322.613-.503 1.094-1.068 1.411-1.678",
    stroke: "#6C7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.489 12.22 1.035 3.865-1.035-3.864Z",
    fill: "#6C7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.489 12.22 1.035 3.865M18.677 10.898l2.828 2.828M2.5 13.726l2.828-2.828M8.464 16.085l1.035-3.864",
    stroke: "#6C7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPreviewClose;